var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("v-office-filter", {
        ref: "officefilter",
        attrs: {
          objectsFetched: _vm.objectsFetched,
          objects: _vm.mapObjects,
          multiSelectFilters: _vm.multiSelectFilters,
          numberOfItems: _vm.totalCount,
          apiKey: this.apiKey,
          translationString: this.translationString,
        },
        on: {
          setMultiSelectFilter: _vm.handleSelectedFilters,
          setSelectedPlacesLength: _vm.handleSelectedPlaces,
          setSelectedTypesOfBuildingsLength: _vm.handleSelectedTypesOfBuildings,
          setMinSize: _vm.handleMinSize,
          setMaxSize: _vm.handleMaxSize,
          setMinWorkplaces: _vm.handleMinWorkplaces,
          setMaxWorkplaces: _vm.handleMaxWorkplaces,
          setSortingOption: _vm.handleSortingOption,
          setFilterIds: _vm.handleFilterIds,
        },
      }),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "c-object-listing o-width-limiter--full",
          staticStyle: { display: "block" },
        },
        [
          _vm.isDesktop &&
          (_vm.processedFilters.length > 0 ||
            _vm.sizeBadgeText ||
            _vm.workplacesBadgeText)
            ? _c(
                "div",
                { staticClass: "selected-filters" },
                [
                  _vm._l(_vm.processedFilters, function (filter, index) {
                    return _c("span", { key: index, staticClass: "badge" }, [
                      _vm._v("\n        " + _vm._s(filter) + "\n        "),
                      _c(
                        "button",
                        {
                          on: {
                            click: function ($event) {
                              return _vm.removeBadge(index)
                            },
                          },
                        },
                        [
                          _c(
                            "span",
                            {
                              staticClass: "c-icon c-icon--xss",
                              attrs: { "aria-hidden": "true" },
                            },
                            [
                              _c("svg", [
                                _c("use", {
                                  attrs: { "xlink:href": "#icon-close" },
                                }),
                              ]),
                            ]
                          ),
                        ]
                      ),
                    ])
                  }),
                  _vm._v(" "),
                  _vm.sizeBadgeText
                    ? _c("span", { staticClass: "badge" }, [
                        _vm._v(
                          "\n        " +
                            _vm._s(_vm.sizeBadgeText) +
                            "\n        "
                        ),
                        _c("button", { on: { click: _vm.removeSizeBadge } }, [
                          _c(
                            "span",
                            {
                              staticClass: "c-icon c-icon--xss",
                              attrs: { "aria-hidden": "true" },
                            },
                            [
                              _c("svg", [
                                _c("use", {
                                  attrs: { "xlink:href": "#icon-close" },
                                }),
                              ]),
                            ]
                          ),
                        ]),
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.workplacesBadgeText
                    ? _c("span", { staticClass: "badge" }, [
                        _vm._v(
                          "\n        " +
                            _vm._s(_vm.workplacesBadgeText) +
                            "\n        "
                        ),
                        _c(
                          "button",
                          { on: { click: _vm.removeWorkplacesBadge } },
                          [
                            _c(
                              "span",
                              {
                                staticClass: "c-icon c-icon--xss",
                                attrs: { "aria-hidden": "true" },
                              },
                              [
                                _c("svg", [
                                  _c("use", {
                                    attrs: { "xlink:href": "#icon-close" },
                                  }),
                                ]),
                              ]
                            ),
                          ]
                        ),
                      ])
                    : _vm._e(),
                ],
                2
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.$refs.officefilter && _vm.$refs.officefilter.showMap
            ? _c(
                "div",
                {
                  staticClass: "c-office-filter__sorting-container",
                  class: {
                    "c-office-filter__sorting-container-mobile": !_vm.isDesktop,
                  },
                },
                [
                  _c("div", { staticClass: "c-office-filter__container" }, [
                    _c("div", { staticClass: "c-office-filter__right-item" }, [
                      _c("span", [_vm._v(_vm._s(this.translate.sorton) + ":")]),
                      _vm._v(" "),
                      _c(
                        "button",
                        {
                          staticClass: "c-office-filter__sorting-select",
                          attrs: { id: "sorting-select" },
                          on: {
                            click: function ($event) {
                              _vm.showSortingOptions = !_vm.showSortingOptions
                            },
                          },
                        },
                        [
                          _vm._v(
                            "\n            " +
                              _vm._s(_vm.activeSorting.display) +
                              "\n            "
                          ),
                          _c(
                            "div",
                            {
                              staticClass:
                                "c-icon c-icon--xs c-office-filter-dropdown__toggle-icon",
                              attrs: { "aria-hidden": "true" },
                            },
                            [
                              _c("svg", [
                                _c("use", {
                                  attrs: { "xlink:href": `#icon-select-arrow` },
                                }),
                              ]),
                            ]
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _vm.showSortingOptions
                        ? _c(
                            "ul",
                            {
                              directives: [
                                {
                                  name: "click-outside",
                                  rawName: "v-click-outside",
                                  value: _vm.handleClickOutside,
                                  expression: "handleClickOutside",
                                },
                              ],
                              staticClass:
                                "c-office-filter__sorting-options-dropdown",
                            },
                            _vm._l(_vm.sortOptions, function (option, index) {
                              return _c(
                                "li",
                                {
                                  key: index,
                                  staticClass:
                                    "c-office-filter__sorting-option",
                                  class: {
                                    "c-office-filter__sorting-option--active":
                                      option === _vm.activeSorting,
                                  },
                                  on: {
                                    click: function ($event) {
                                      return _vm.selectSortingOption(option)
                                    },
                                  },
                                },
                                [
                                  option === _vm.activeSorting
                                    ? _c(
                                        "div",
                                        {
                                          staticClass:
                                            "c-icon c-icon--xs c-office-filter__check-icon",
                                          attrs: { "aria-hidden": "true" },
                                        },
                                        [
                                          _c("svg", [
                                            _c("use", {
                                              attrs: {
                                                "xlink:href": `#icon-check`,
                                              },
                                            }),
                                          ]),
                                        ]
                                      )
                                    : _vm._e(),
                                  _vm._v(
                                    "\n              " +
                                      _vm._s(option.display) +
                                      "\n            "
                                  ),
                                ]
                              )
                            }),
                            0
                          )
                        : _vm._e(),
                    ]),
                  ]),
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "c-object-listing__items" },
            _vm._l(_vm.filteredObjects, function (object, index) {
              return _c(
                "div",
                { key: index, staticClass: "c-object-listing__item" },
                [
                  _c("v-object-card", {
                    attrs: {
                      url: _vm.normalizeProperty(object, "url"),
                      image: _vm.normalizeProperty(object, "image"),
                      images: _vm.normalizeProperty(object, "images"),
                      title: _vm.normalizeProperty(object, "title"),
                      sizeFrom: _vm.normalizeProperty(object, "sizeFrom"),
                      sizeTo: _vm.normalizeProperty(object, "sizeTo"),
                      city: _vm.normalizeProperty(object, "city"),
                      district: _vm.normalizeProperty(object, "district"),
                      id: _vm.objectId(object),
                      address: _vm.normalizeProperty(object, "address"),
                      premiseTypes:
                        _vm.normalizeProperty(object, "premiseTypes") ||
                        _vm.normalizeProperty(object, "PremiseTypes"),
                      features: _vm.normalizeProperty(
                        object,
                        "selectedFeatures"
                      ),
                      selectedFeatures: _vm.normalizeProperty(
                        object,
                        "selectedFeatures"
                      ),
                      overflowFeaturesCount: _vm.normalizeProperty(
                        object,
                        "overflowFeaturesCount"
                      ),
                      numberOfWorkplaces: _vm.normalizeProperty(
                        object,
                        "numberOfWorkplaces"
                      ),
                      minNumberOfWorkplaces: _vm.normalizeProperty(
                        object,
                        "minNumberOfWorkplaces"
                      ),
                      maxNumberOfWorkplaces: _vm.normalizeProperty(
                        object,
                        "maxNumberOfWorkplaces"
                      ),
                      pricePerSquare: _vm.normalizeProperty(
                        object,
                        "pricePerSquare"
                      ),
                    },
                  }),
                ],
                1
              )
            }),
            0
          ),
          _vm._v(" "),
          _vm.isLoading
            ? _c("div", { staticClass: "c-object-listing__loading" }, [
                _c("div", { staticClass: "c-loading" }, [
                  _c("span", { staticClass: "t-visually-hidden" }, [
                    _vm._v(_vm._s(this.translate.loading) + "..."),
                  ]),
                ]),
              ])
            : _vm._e(),
          _vm._v(" "),
          !_vm.isLoading && _vm.hasMorePages
            ? _c("div", { staticClass: "c-object-listing__pagination" }, [
                _c("p", { staticClass: "c-object-listing__pagination-count" }, [
                  _vm._v(
                    "\n        " +
                      _vm._s(_vm.translate.showing || "Visar") +
                      "\n        "
                  ),
                  _c(
                    "span",
                    {
                      staticClass:
                        "c-object-listing__pagination-count-highlight",
                    },
                    [
                      _vm._v(
                        "\n          " +
                          _vm._s(_vm.filteredObjects.length) +
                          " " +
                          _vm._s(_vm.translate.of || "av") +
                          "\n          " +
                          _vm._s(_vm.totalCount) +
                          "\n        "
                      ),
                    ]
                  ),
                  _vm._v(
                    "\n        " +
                      _vm._s(_vm.translate.premises || "lokaler") +
                      "\n      "
                  ),
                ]),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "c-object-listing__pagination-button",
                    attrs: { disabled: _vm.isLoadingMore },
                    on: { click: _vm.loadMore },
                  },
                  [
                    _vm.isLoadingMore
                      ? _c(
                          "span",
                          {
                            staticClass:
                              "c-object-listing__pagination-button-loading",
                          },
                          [
                            _vm._v(
                              "\n          " +
                                _vm._s(_vm.translate.loading || "Laddar") +
                                "...\n        "
                            ),
                          ]
                        )
                      : _c("span", [
                          _vm._v(
                            "\n          " +
                              _vm._s(
                                _vm.translate.showmorepremises ||
                                  "Visa fler lokaler"
                              ) +
                              "\n        "
                          ),
                        ]),
                  ]
                ),
              ])
            : _vm._e(),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }